import { createGlobalState } from "react-hooks-global-state"

export const { useGlobalState } = createGlobalState({
  sidebar: false,
  contactDialog: false,
  rtl: false,
  alert: null,
})
